<template>
  <el-dialog
    :before-close="handlecrile"
    :visible.sync="shopVisible"
    append-to-body
    title="选择商品"
    width="60%"
  >
    <div style="padding-bottom: 40px">
      <el-form :inline="true">
        <el-form-item label="商品名" label-width="80px">
          <el-input
            v-model="shopForm.name"
            clearable
            placeholder="商品名"
            @keyup.enter.native="getsch()"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="商品分类" label-width="80px">
          <el-cascader
            @change="getsch"
            ref="cateData"
            v-model="shopForm.classifyId"
            :options="typeList"
            :props="{
              checkStrictly: true,
              value: 'id',
              label: 'name',
              children: 'children',
            }"
            clearable
            filterable
            placeholder="选择分类"
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="getsch()">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="shopData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column align="center" label="商品封面" prop="storeGoodsCover">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.cover"
              fit="scale-down"
              style="width: 70px; height: 70px"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="商品名称"
          prop="name"
        ></el-table-column>
        <el-table-column
          align="center"
          label="商品类型"
          prop="firstClassifyName"
        >
          <template slot-scope="scope">
            {{ scope.row.firstClassifyName }}-{{ scope.row.classifyName }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          prop="icon"
          width="140"
        >
          <template slot-scope="scope">
            <el-button plain type="primary" @click="chooseshop(scope.row)"
              >{{ tcommodityId == scope.row.id ? "已选择" : "选择" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="shopForm.pageNo"
        :page-size="shopForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="shopSizeChange"
        @current-change="shopCurrentChange"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      tcommodityId: null,
      total: 0,
      shopData: [],
      shopVisible: false,
      typeList: [],
      shopForm: {
        pageNo: 1,
        pageSize: 10,
        classifyId: [],
        name: "",
      },
    };
  },
  methods: {
    handlecrile() {
      this.shopForm.pageNo = 1;
      this.tcommodityId = null;
      this.shopVisible = false;
    },
    chooseshop(e) {
      this.$emit("selectgoods", e);
      this.handlecrile();
    },
    init(id) {
      this.tcommodityId = id ? id : null;
      this.getTypeList();
      this.getsch();
      this.shopVisible = true;
    },
    shopCurrentChange(val) {
      this.shopForm.pageNo = val;
      this.getStoreGoods();
    },
    shopSizeChange(val) {
      this.shopForm.pageSize = val;
      this.getStoreGoods();
    },
    getsch() {
      this.shopForm.pageNo = 1;
      this.getStoreGoods();
    },
    getStoreGoods() {
      var obj = JSON.parse(JSON.stringify(this.shopForm));
      var iv = {};
      if (obj.classifyId.length > 0) {
        iv.classifyFirstId = obj.classifyId[0];
        if (obj.classifyId.length > 1) {
          this.typeList.map((item) => {
            item.children.map((itrs) => {
              if (obj.classifyId[1] == itrs.id) {
                iv.classifyId = itrs.uid;
              }
            });
          });
        } else {
          iv.classifyId = "";
        }
      } else {
        iv.classifyId = "";
        iv.classifyFirstId = "";
      }
      iv.pageNo = obj.pageNo;
      iv.pageSize = obj.pageSize;
      iv.name = obj.name;
      iv.type = 0;
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", iv)
        .then((res) => {
          this.shopData = res.data.records;
          this.total = res.data.total;
        });
    },
    getTypeList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.typeList = res.data;
        });
    },
  },
};
</script>

<style scoped></style>
